import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  SubTable,
  Timestamp,
  type SubTableColumn,
} from "@/design-system/components/ui";
import type { InterviewWordingVersion } from "@/types/interviewWording";

const COLUMNS: SubTableColumn<InterviewWordingVersion>[] = [
  { key: "v", header: "Version", render: (v) => `v${v.versionNumber}` },
  { key: "when", header: "Published", render: (v) => <Timestamp value={v.publishedAtUtc} absolute /> },
  { key: "who", header: "By", render: (v) => v.publishedByUserName ?? "—" },
  { key: "note", header: "Note", render: (v) => v.note ?? "—" },
];

/**
 * Every published wording version, read-only. There is deliberately no restore:
 * to go back, reword the item (or revert it to its default) and publish again.
 */
export function VersionList({ versions }: { versions: InterviewWordingVersion[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Version history</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-space-2">
        <p className="m-0 text-caption text-gray-mid">
          The newest version is what the interview reads. A completed interview keeps showing the
          wording it was completed under.
        </p>
        <SubTable
          columns={COLUMNS}
          rows={versions}
          rowKey={(v) => String(v.versionNumber)}
          caption="Interview wording versions"
          empty={{ message: "Nothing has been published — the coded defaults are in force." }}
        />
      </CardContent>
    </Card>
  );
}
